module.exports = __webpack_public_path__ + "static/img/bg-12.1c71daa4.jpg";